import React, {Component } from 'react';
import PropTypes from 'utils/propTypes';
import bn from 'utils/bemnames';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Tipografia from './Tipografia';
import { buscarUsuarioLogado } from "./usuario/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";


class Pagina extends Component {

  componentDidMount() {
    if(! this.props.usuarioLogado){
      this.props.buscarUsuarioLogado();
    }
  }

  render(){
    const {
      title,
      breadcrumbs,
      tag: Tag,
      className,
      children,
      ...restProps
    } = this.props;

    const bem = bn.create('page');
    const classes = bem.b('px-3', className);

    return (
    <Tag className={classes} {...restProps}>
      <div className={bem.e('header')}>
      {
          breadcrumbs && (
            <Breadcrumb className={bem.e('breadcrumb')}>
              <BreadcrumbItem>RADAR</BreadcrumbItem>
              <BreadcrumbItem>RECURSO DE INFRAÇÕES</BreadcrumbItem>
              <BreadcrumbItem>{this.props.usuarioLogado.cliente}</BreadcrumbItem>

              {breadcrumbs.length &&
                breadcrumbs.map(({ name, active }, index) => (
                  <BreadcrumbItem key={index} active={active}>
                    {name}
                  </BreadcrumbItem>
                ))}
            </Breadcrumb>
          )
        }
        {
          title && typeof title === 'string'
            ? (<Tipografia type="h1" className={bem.e('title')}>{title}</Tipografia>)
            : (title)
        }

      </div>
      {children}
    </Tag>
    );
  }
}

Pagina.propTypes = {
  tag: PropTypes.component,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  children: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      active: PropTypes.bool,
    })
  ),
};

Pagina.defaultProps = {
  tag: 'div',
  title: '',
};


const mapStateToProps = state => ({
  usuarioLogado: state.usuario.usuarioLogado
});

const mapDispatchToProps = dispatch => bindActionCreators({
  buscarUsuarioLogado
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Pagina);



// WEBPACK FOOTER //
// ./src/componentes/Pagina.js